module.exports = __webpack_public_path__ + "templates/points-list.html";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/points/templates/points-list.html
// module id = kRCj
// module chunks = 1